import React from "react";
import { FiDownload, FiFileText, FiLoader, FiCpu, FiCheckCircle, FiFile, FiCheck } from "react-icons/fi";

export default function DownloadStep({
  NavigationButtons,
  downloadReady,
  documentTypes,
  selectedDocType,
  uploadedFiles,
  processRows,
  vocabularyChanges,
  clientMappings,
  handlePrepareDownload,
  isProcessing,
  handleDownload,
  onComplete,
}) {
  return (
    <div className="wizard-step-content">
      <div className="step-header-with-nav">
        <div className="step-header-left">
          <div className="step-icon-wrapper">
            <FiDownload className="step-icon" />
          </div>
          <div className="step-header-text">
            <h2 className="step-title">Download</h2>
            <p className="step-subtitle">Export the migrated document in the original format</p>
          </div>
        </div>
        <NavigationButtons />
      </div>

      <div className="form-section">
        {!downloadReady ? (
          <div className="download-prepare">
            <div className="download-info">
              <FiFileText className="download-info-icon" />
              <h3>Prepare Document for Download</h3>
              <p>Click below to finalize and prepare your migrated document</p>
            </div>

            <div className="download-summary">
              <div className="summary-row">
                <span>Document Type:</span>
                <span>{documentTypes.find((documentType) => documentType.id === selectedDocType)?.name || "N/A"}</span>
              </div>
              <div className="summary-row">
                <span>Files Processed:</span>
                <span>{uploadedFiles.length}</span>
              </div>
              <div className="summary-row">
                <span>Rows Transformed:</span>
                <span>{processRows.length}</span>
              </div>
              <div className="summary-row">
                <span>Vocabulary Changes:</span>
                <span>{vocabularyChanges.filter((vocabularyChange) => vocabularyChange.applied).length}</span>
              </div>
              <div className="summary-row">
                <span>Custom Mappings Used:</span>
                <span>{clientMappings.filter((mapping) => mapping.enabled).length}</span>
              </div>
            </div>

            <button
              className="prepare-download-btn"
              onClick={handlePrepareDownload}
              disabled={isProcessing}
            >
              {isProcessing ? (
                <>
                  <FiLoader className="spinner" /> Preparing...
                </>
              ) : (
                <>
                  <FiCpu /> Prepare Download
                </>
              )}
            </button>
          </div>
        ) : (
          <div className="download-ready">
            <div className="download-success">
              <FiCheckCircle className="success-icon-large" />
              <h3>Document Ready!</h3>
              <p>Your migrated document is ready for download</p>
            </div>

            <div className="download-file-preview">
              <FiFile className="file-preview-icon" />
              <div className="file-preview-info">
                <span className="file-preview-name">
                  {uploadedFiles.length > 0 ? `migrated_${uploadedFiles[0].name}` : "migrated_document.txt"}
                </span>
                <span className="file-preview-details">Same format and font as original</span>
              </div>
            </div>

            <button className="download-btn" onClick={handleDownload}>
              <FiDownload /> Download Document
            </button>

            <button className="complete-btn" onClick={onComplete}>
              <FiCheck /> Complete Migration
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
